import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../Store";
import { Graph_QL } from "../../../../Services";
import { useDeviceInfo } from "../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useDeviceInfo";
import { colors, frames } from "../../../../Styles";
import { PageHeader } from "../../../../Components";

// TODO
import IoTable from "../../../../Components/Settings/ioTable";
import { useParams } from "react-router";
import { useSystem } from "../../../../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem";
import { Pages } from "../../../../Navigation/Routers/root";
import LfSettings from "../../../../Components/LocationFeeder/lfSettings";

const SYSTEM_ID = 1;

export default function FreedaLocationFeeder() {
  const { t } = useTranslation();

  const { systemId: urlSystemId } = useParams(); // TODO routing changes in order to get a correct system info
  const systemId = urlSystemId ? +urlSystemId : SYSTEM_ID;

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getSystemCall, data: systemsState } = useSystem(connection);

  useEffect(() => {
    getSystemCall({ ids: [systemId] });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get System Name for Header
  const system = useMemo(() => {
    return systemsState[domain]?.data.find(
      (system) => system.systemId === systemId
    );
  }, [domain, systemId, systemsState]);
  
  const { data: deviceInfoState, call: getDeviceInfo, maintainEntries: maintainDeviceInfo } = useDeviceInfo(connection);

  const deviceInfo = useMemo(() => {
    if (deviceInfoState[domain]) {
      return deviceInfoState[domain].data;
    }
    return [];
  }, [deviceInfoState, domain]);

  useEffect(() => {
    getDeviceInfo({ fetchAmount: 500 }, connection);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // #endregion

  const seperator = <div style={{ width: "95%", height: "1px", backgroundColor: colors.greyDarkPrimary }} />

  return (
    <frames.Page_inner>
      <frames._page_inner_header>
        <PageHeader topHeader={system?.name} subHeader={t(`menuHeaders.${Pages.freeda_lf_settings}`, { defaultValue: "settings" })} />
      </frames._page_inner_header>
      <frames._page_inner_content_scroll>
        
        <div style={{ display: "flex", gap: "20px", alignItems: "center", justifyContent: "center", flexDirection: "column" }} >
          <LfSettings/>
          {seperator}
          <IoTable deviceInfo={deviceInfo} maxTableHeight="400px" showSystemRow={false} maintainDeviceInfo={maintainDeviceInfo} />
        </div>
        
      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}
